import { render, staticRenderFns } from "./CompetenzeList.vue?vue&type=template&id=400bc6f0&scoped=true&"
import script from "./CompetenzeList.vue?vue&type=script&lang=js&"
export * from "./CompetenzeList.vue?vue&type=script&lang=js&"
import style0 from "./CompetenzeList.vue?vue&type=style&index=0&id=400bc6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400bc6f0",
  null
  
)

export default component.exports